module.exports = __webpack_public_path__ + "img/logo_bak.77e7d5fd.svg";